import React, { useState, useEffect } from 'react';
import LayoutProvider from '../../../providers/LayoutProvider';
import { deleteFlightsAdmin, deleteUser, getAdminFlights, getUserbyId, getUsers, statusChange, updateUser } from '../../../components/Axios/Axios';
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import AdminPagesProvider from '../../../providers/AdminPagesProvider';
import { FaEllipsisH } from 'react-icons/fa';
import Dropdown from 'react-bootstrap/Dropdown';
import useCustomToast from '../../../hooks/useCustomToast';
import { Toaster } from 'react-hot-toast';
import ReactPaginate from 'react-paginate';
import SpinnerLoader from '../../../components/SpinnerLoader';
import { API_STATUS } from '../../../constants';
import Animations from '../../../components/TableSkeleton';

export default function AdminFlights() {
    const [rows, setRows] = useState([]);
    const navigate = useNavigate();
    const customToast = useCustomToast();
    const [active, setActive] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalPages, setTotalPages] = useState(0)
    const [loading, setLoading] = useState(false)


    const handleDelete = async (id: any) => {
        try {
            await deleteFlightsAdmin(id);
            console.log(id)
            fetchData();
            customToast("User deleted successfully", "success");
        } catch (error) {
            console.error('Error deleting user:', error);
            customToast("Error deleting user", "error");
        }
    };


    //View User
    const handleView = (id: any) => {
        navigate(`/admin/edit-user/${id}`);
    }

    const columns = [
        {
            name: 'Date',
            selector: (row: any) => row?.flightDate?.slice(0,10) || "-",
            sortable: true,
            grow: 3,
            wrap: true,
        },
        {
            name: 'Flight',
            selector: (row: any) => row?.route || "-",
            sortable: true,
            grow: 3,
            wrap: true,
        },
        {
            name: 'Aircraft',
            selector: (row: any) => row?.aircraft?.model || "-",
            grow: 1,
            wrap: true,
        },
        {
            name: 'Lndgs.',
            selector: (row: any) => row?.landingsAndApproaches?.totalLandings,
            grow: 1,
            wrap: true,
        },
        {
            name: 'Day',
            selector: (row: any) => row?.times?.day,
            grow: 1,
            wrap: true,
        },
        {
            name: 'Night',
            selector: (row: any) => row?.times?.night,
            grow: 1,
            wrap: true,
        },
        {
            name: 'X-C',
            selector: (row: any) => row?.times?.crossCountry,
            grow: 1,
            wrap: true,
        },
        {
            name: 'IMC',
            selector: (row: any) => row?.times?.imc,
            grow: 1,
            wrap: true,
        },
        // {
        //     name: 'Grnd. Sim.',
        //     selector: (row: any) => row?.times.simInstrument,
        //     grow: 1.2,
        //     wrap: true,
        // },
        {
            name: 'PIC',
            selector: (row: any) => row?.times?.pic,
            grow: 1,
            wrap: true,
        },
        {
            name: 'SIC',
            selector: (row: any) => row?.times?.sic,
            grow: 1,
            wrap: true,
        },
        {
            name: 'Total',
            selector: (row: any) => row?.times?.totalTimeHours,
            grow: 1,
            wrap: true,
        },
       
        {
            cell: (row: any) => (
                <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic" style={{ background: "none", color: "#5b5b5b", border: "none" }}>
                        <FaEllipsisH />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item type='button' onClick={() => handleDelete(row._id)}>Delete</Dropdown.Item>
                        {/* <Dropdown.Item href="#/action-2" onClick={() => handleView(row._id)} >Edit</Dropdown.Item> */}
                        {/* <Dropdown.Item href="#/action-3">{row.isActive?"Deactivate":"Activate"}</Dropdown.Item> */}
                        {/* <Dropdown.Item onClick={() => navigate(`/admin/users/user-stats/${row._id}`)}>View Stats</Dropdown.Item> */}
                    </Dropdown.Menu>
                </Dropdown>
            ),
            grow: 1,
            wrap: true,
        },
    ];

    const fetchData = async () => {
        try {
            setLoading(false)
            const response = await getAdminFlights(currentPage);
            const flights = response.data || [];
            const page = response.paginator;
            setItemsPerPage(page.perPage)
            setTotalPages(page.totalPages)
            setRows(flights);
            setLoading(true)
        } catch (error) {
            setLoading(true)
            console.error('Error fetching user data:', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [currentPage]); // Fetch data on initial render

    const handleClick = () => {
        navigate('/admin/invite-users');
    };

    const handlePageChange = ({ selected }: { selected: number }) => {
        setCurrentPage(selected + 1); // Adjust currentPage value to start from 1
    };


    return (
        <AdminPagesProvider>
            <LayoutProvider>
                {loading === false && <SpinnerLoader />}
                <h6 className="dashboard_subheading">Dashboard {'>'} Flights</h6>
                <section
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    <h4 className="dashboard_heading">Flights</h4>
                    {/* <div>
                        <button className="button" onClick={handleClick}>
                            Invite users
                        </button>
                    </div> */}
                </section>
                <div style={{ width: '100%', marginTop: '2%' }}>
                    <Toaster />
                    <DataTable
                        columns={columns}
                        data={rows || []}
                        selectableRows
                        // pagination
                        // paginationPerPage={paginator.perPage}
                        // paginationTotalRows={paginator.itemCount}
                        // onRowClicked={(row) => {
                        //   navigate(`/admin/edit-user/${row?._id}`);
                        // }}
                        customStyles={{
                            rows: {
                                style: {
                                    minHeight: '60px',
                                    '&:nth-child(odd)': {
                                        background: '#EFF6FF',
                                    },
                                },
                            },
                            headCells: {
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                },
                            },
                            cells: {
                                style: {
                                    fontSize: '14px',
                                },
                            },
                        }}
                    />
                    <div className="pagination-container-one">
                        <ReactPaginate
                            previousLabel={"Prev"}
                            nextLabel={"Next"}
                            breakLabel={"..."}
                            breakClassName={"break-me"}
                            pageCount={totalPages}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={3}
                            onPageChange={handlePageChange}
                            containerClassName={"pagination"}
                            activeClassName={"active"}
                        />
                    </div>
                </div>
            </LayoutProvider>
        </AdminPagesProvider>
    );
}
